<script setup lang="ts">
// The shell is intentionally empty: each layout supplies its own chrome so the
// auth screens do not inherit the signed-in header.
</script>

<template>
  <router-view />
</template>
